module.exports = __webpack_public_path__ + "static/media/expand.8e74137f.svg";